import { render } from "./TabUtente.vue?vue&type=template&id=e91ce572&scoped=true"
import script from "./TabUtente.vue?vue&type=script&lang=js"
export * from "./TabUtente.vue?vue&type=script&lang=js"

import "./TabUtente.vue?vue&type=style&index=0&id=e91ce572&scoped=true&lang=css"
import "./TabUtente.vue?vue&type=style&index=1&id=e91ce572&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91ce572"]])

export default __exports__